<template>
  <div :class="$style.offlinePay">
    <Product @bindAccount="bindAccount" v-if="productVisible"></Product>
    <Popup
      :value="bindVisible"
      @click-close-icon="closePopup"
      closeable
      :close-on-click-overlay="false"
    >
      <BindAccount ref="bindAccount" @close="closePopup" @bindSuccess="bindSuccess" @getPayType="getPayType"></BindAccount>
    </Popup>
    <Charge v-if="chargeVisible"></Charge>
    <Record v-if="recordVisible"></Record>
    <Bind v-if="bindPageVisible" @showBindToast="bindAccount"></Bind>
    <p :class="$style.hint" v-if="hintVisible">链接失效，请点击下方菜单栏【灵符兑换】按键进行充值。</p>
  </div>
</template>

<script>
import Product from "./product.vue";
import BindAccount from "./bindAccount.vue";
import Charge from "./charge.vue";
import Record from "./record.vue";
import Bind from './bind';
import offlinePayGame from "@/config/offlinePayGame";
import wxSdkInit from "@/libs/wx.init.js";
import { Popup } from "vant";
import { mapState, mapMutations, mapActions } from "vuex";
import { isWeiXin } from "@/libs/utils";
import { productList } from "@/api/pay";
import { cyGames } from '@/config/offlinePayGame';

export default {
  name: "offlinePay",
  data() {
    return {
      hintVisible: false
    };
  },
  mounted() {
    if (location.hostname==='wap.921game.cn' && location.pathname === '/offlinePay/dwry') {
      this.hintVisible = true
    }
    // 同时也获取了微信绑定角色信息和初始化微信sdk
    this.getBaseInfo();
  },
  computed: {
    ...mapState({
      bindVisible: (state) => state.offlinePay.bindVisible,
      chargeVisible: (state) => state.offlinePay.chargeVisible,
      recordVisible: (state) => state.offlinePay.recordVisible,
      bindPageVisible: (state) => state.offlinePay.bindPageVisible,
      productVisible: (state) => state.offlinePay.productVisible,
    }),
  },
  methods: {
    ...mapMutations({
      setOfflinePayState: "offlinePay/setState",
    }),
    ...mapActions({
      getUserRole: "offlinePay/getUserRole",
      getGoodsList: "offlinePay/getGoodsList",
      getPayType: "offlinePay/getPayType"
    }),
    closePopup() {
      this.setOfflinePayState({ bindVisible: false });
    },
    bindAccount() {
      this.setOfflinePayState({
        bindVisible: true,
      });
      this.$refs.bindAccount && this.$refs.bindAccount.reset();
    },
    bindSuccess() {
      this.setOfflinePayState({ bindVisible: false, bindPageVisible: false, productVisible: true });
    },
    // 根据配置链接name从配置中获取游戏信息 商品信息
    getBaseInfo() {
      const { name } = this.$route;
      const game = name.split(".")[1];
      this.setOfflinePayState({
        appkey: offlinePayGame[game].appkey,
        appId: offlinePayGame[game].appId,
        game: offlinePayGame[game].game,
        gameIcon: offlinePayGame[game].gameIcon,
        gameFlag: game,
      });
      if (cyGames.includes(game)) {
        // 赤焰联击实际就是代币，不从研发取商品
        this.setOfflinePayState({
          goodsList: offlinePayGame[game].goods,
          hiddenTab: true,
        });
      } else {
        this.setOfflinePayState({
          hiddenTab: false
        });
      }
      if (isWeiXin()) {
        wxSdkInit(offlinePayGame[game].appkey, offlinePayGame[game].appId);
        this.getUserRole();
      } else {
        this.setOfflinePayState({ productVisible: true });
        let roleInfo = localStorage.getItem("role_info");
        try {
          roleInfo = JSON.parse(roleInfo);
          if (!roleInfo || roleInfo.game_flag !== game) {
            this.setOfflinePayState({
              bindVisible: true,
            });
            return;
          }
          this.setOfflinePayState({ bindRoleInfo: roleInfo });
          this.getPayType({ appkey: offlinePayGame[game].appkey, roleInfo });
          if (!cyGames.includes(game)) {
            this.getGoodsList()
          }
        } catch (err) {
            this.setOfflinePayState({
              bindVisible: true,
            });
        }
      }
    }
  },
  components: {
    Product,
    Popup,
    BindAccount,
    Charge,
    Record,
    Bind
  },
};
</script>

<style lang="scss" module>
.offlinePay {
  height: 100%;
  :global {
    .van-popup {
      background-color: transparent;
    }
    .van-popup__close-icon--top-right {
      top: 10px;
      right: 10px;
    }
  }
  .hint {
    background: #FFFFFF;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
  }
}
</style>